export const excludedPaths = [
    '/api/resources/sap-document-type',
    '/api/resources/sap-aliado-list',
    '/api/resources/sap-categoria-list',
    '/api/aspirants/utm/save',
    '/aspirants/fast-register',
    '/users/resend-confirmation',
    '/users/initiate-password-change',
    '/users/confirm-email'
]

export const isExludedPath = (url?: string) => {
    if (!url) {
        return false
    }

    return excludedPaths.some((path) => url.includes(path))
}
